const apiUrl = process.env.REACT_APP_API_URL;

function getBasicAuthHeader() {
  const username = process.env.REACT_APP_API_USERNAME;
  const password = process.env.REACT_APP_API_PASSWORD;
  return `Basic ${btoa(`${username}:${password}`)}`;
}

function authHeaders() {
  return {
    'Content-Type': 'application/json',
    Accept: '*/*',
    Authorization: getBasicAuthHeader(),
  };
}

/** Live payout-account (Stripe Connect) status. */
export async function fetchConnectStatus(userId) {
  const res = await fetch(`${apiUrl}/api/stripe/connect/status/${userId}`, { headers: authHeaders() });
  if (!res.ok) throw new Error(`Connect status failed: ${res.status}`);
  return res.json();
}

/** Express: hosted onboarding link (creates the managed account on first call). */
export async function createOnboardingLink(userId) {
  const res = await fetch(`${apiUrl}/api/stripe/connect/onboarding-link`, {
    method: 'POST', headers: authHeaders(), body: JSON.stringify({ userId }),
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(body.error || `Onboarding link failed: ${res.status}`);
  return body;
}

/** Standard: "Connect with Stripe" OAuth authorize URL. */
export async function fetchOAuthUrl(userId) {
  const res = await fetch(`${apiUrl}/api/stripe/connect/oauth-url/${userId}`, { headers: authHeaders() });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(body.error || `OAuth URL failed: ${res.status}`);
  return body;
}

/** Standard: complete OAuth after Stripe redirects back with a code. */
export async function completeOAuth(userId, code) {
  const res = await fetch(`${apiUrl}/api/stripe/connect/oauth-complete`, {
    method: 'POST', headers: authHeaders(), body: JSON.stringify({ userId, code }),
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(body.error || `OAuth complete failed: ${res.status}`);
  return body;
}

/** Instructor earnings: connected-account balance, payouts, and activity. */
export async function fetchIncome(userId) {
  const res = await fetch(`${apiUrl}/api/stripe/connect/income/${userId}`, { headers: authHeaders() });
  if (!res.ok) throw new Error(`Income request failed: ${res.status}`);
  return res.json();
}

/** Express dashboard login link. */
export async function createDashboardLink(userId) {
  const res = await fetch(`${apiUrl}/api/stripe/connect/dashboard-link`, {
    method: 'POST', headers: authHeaders(), body: JSON.stringify({ userId }),
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(body.error || `Dashboard link failed: ${res.status}`);
  return body;
}
